
import Vue from 'vue'
import axios from '@/utils/axios_utils'
import { gaEventTracker, EVENT_CATEGORIES, EVENT_NAMES, EVENT_LABELS } from '@/utils'
import { ENDPOINTS } from '@/pages/product/const'
import { getJsonData } from '@/utils/dom'
import { OPTION_ERROR_MESSAGES, SUBMISSION_FILE_EXTENSIONS } from '@/pages/product/const'
import EDITOR_ICON from 'editor/icon-edit.svg'
import UPLOAD_ICON from 'editor/icon-upload.svg'

export default Vue.extend({
  name: 'EditorBtn',
  computed: {
    EDITOR_ICON(): string {
      return EDITOR_ICON
    },
    UPLOAD_ICON(): string {
      return UPLOAD_ICON
    },
    fileExtensions(): string{
      return '.' + SUBMISSION_FILE_EXTENSIONS.join(',.')
    },
    editorUrl(): string {
      return `/editor?psi=${this.$store.getters.estimate.printable_sku_id}&quantity=${this.$store.getters.estimateQuantity}&trial=${this.$store.getters.estimate.trial}`
    },
    disableLink(): boolean {
      return !this.$store.getters.isSendable || this.$store.state.productLoading
    }
  },
  methods: {
    handleDesignTool() {
      this.eventTracker(EVENT_NAMES.USE_DESIGN_TOOL)
      window.location.href = this.editorUrl
    },
    handleDesignFile(e: InputEvent) {
      this.eventTracker(EVENT_NAMES.CLICK_UPLOAD_DESIGN)
      const el = e.target as HTMLInputElement
      const fileList = el.files
      if (fileList && fileList[0]) {
        const fileListExt =  fileList[0].name.split('.').pop()?.toLowerCase()
        if (!this.isValidFileExtension(fileListExt)) {
          this.eventTracker(EVENT_NAMES.FAILED_UPLOAD_DESIGN)
          alert(OPTION_ERROR_MESSAGES.FILE_EXTENSION_VALIDATE)
          this.resetFileInput()
          return
        } else if (this.isValidFileSize(fileList[0].size)) {
          this.eventTracker(EVENT_NAMES.FAILED_UPLOAD_DESIGN)
          alert(OPTION_ERROR_MESSAGES.FILE_SIZE_VALIDATE)
          this.resetFileInput()
          return
        } else {
          const formData = new FormData()
          formData.append('file', fileList[0])
          if (formData) {
            this.handleCreateSubmission(formData)
          }
        }
      }
    },
    handleCreateSubmission(file?: any) {
      const payload = {file: ''}
      if (file) payload.file = file
      this.$store.commit('setProductLoading', true)
      this.$store.dispatch('uploadDesignFile', payload).then(data => {
        if (file instanceof FormData) {
          this.eventTracker(EVENT_NAMES.COMPLETE_UPLOAD_DESIGN)
        }
        this.resetFileInput()
        if (data && data.submission_uuid){
          this.handleAddToCart(data.submission_uuid)
        }
      })
    },
     handleAddToCart(uuid: string) {
      const signUpURL = getJsonData('#sign-up-url')
      const isUserLogin = getJsonData('#current-user')
      const setNewCartEndpoint = isUserLogin ? '/cart' : `${signUpURL}?referral=${window.location.origin}/cart`

      const printColor = this.$store.state.currentPrintColor
      const printColorId = printColor ? [printColor.id] : []
       const colorIdsParam = {
        sku_printable_special_color_ids: printColorId
      }

      const params = {
        printable_sku_id: this.$store.state.estimate.printable_sku_id,
        quantity: this.$store.state.estimate.quantity,
        trial: false,
        submission_uuids: [uuid],
        data_check_preference: 'speed',
        ...colorIdsParam
      }
      axios.post(ENDPOINTS.CART_ITEMS, params).then(() => {
        location.href = setNewCartEndpoint
         this.eventTracker(EVENT_NAMES.ADD_TO_CART)
      }).catch(err => {
        alert(err || OPTION_ERROR_MESSAGES.CART_ITEM_VALIDATE)
      }).finally(() => {
        this.$store.commit('setProductLoading', false)
      })
    },
    isValidFileExtension(extension: string): boolean {
      return SUBMISSION_FILE_EXTENSIONS.includes(extension)
    },
    isValidFileSize(fileSize: number): boolean {
      // File size 100 MB in bytes
      const maxFileSize = 100 * 1024 * 1024
      return fileSize > (maxFileSize)
    },
    resetFileInput() {
      this.$refs?.file_upload?.value = null
      this.$store.commit('setProductLoading', false)
    },
    eventTracker(event_name: string) {
      const payload = {
        event_category:  EVENT_CATEGORIES.DESIGN_OPTIONS,
        event_label: EVENT_LABELS.PRODUCT_PAGE
      }
      gaEventTracker(event_name, payload)
    }
  }
})
